const Spinner = ({
  colorClass = "white",
  size = "w-4 h-4",
  thickness = "border-1",
}: any) => {
  return (
    <div
      className={`inline-block mt-1 mr-2 animate-spin rounded-full border-solid border-t-transparent ${size} ${thickness} ${colorClass}`}
    />
  );
};

export default Spinner;
